
  import { css } from 'lit';
  export const styles = css`:host{--component-size: var(--ig-size, var(--default-size)) !important;border:var(--border-width) solid var(--border-color)}`;
  